export default {
  RESET_STATE: 'faq/reset_state',

  INIT_REQUEST: 'faq/init/request',
  INIT_SUCCESS: 'faq/init/success',
  INIT_FAILURE: 'faq/init/failure',
}
